import { Button, Icon } from '@iwoca/orion';
import { Trans } from '@lingui/macro';

import { getLoginUrl } from 'lendingApi/lendingApi';
import styles from '../Navigation.module.css';

export const LoginItem = () => {
  return (
    <div className={styles.navItem}>
      <Button
        className={styles.navButton}
        variant="tertiary"
        href={getLoginUrl()}
      >
        <Trans>Log in</Trans>
        <Icon icon="lockOpenFilled" className={styles.icon} />
      </Button>
    </div>
  );
};
